import React, { useState, useEffect } from 'react'

function ResponsePopup({ showPopup, setShowPopup, title, results = [] }) {

    if (!showPopup) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.5)',
            zIndex: 99999,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            animation: 'fadeIn 0.2s ease-out'
        }}>
            <div style={{
                background: '#ffffff',
                borderRadius: '8px',
                width: '600px',
                maxWidth: '90vw',
                maxHeight: '85vh',
                boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
            }}>
                {/* Header */}
                <div style={{
                    padding: '16px 24px',
                    backgroundColor: '#ffffff',
                    borderBottom: '1px solid #eaeaea',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <i className="fas fa-tasks" style={{ fontSize: '18px', color: '#0d6efd' }}></i>
                        <h3 style={{ margin: 0, fontSize: '16px', fontWeight: '600', color: '#333' }}>
                            {title}
                        </h3>
                    </div>
                    <button
                        onClick={() => setShowPopup(false)}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            color: '#999',
                            fontSize: '22px',
                            cursor: 'pointer',
                            padding: '0 4px',
                            lineHeight: '1'
                        }}
                    >
                        &times;
                    </button>
                </div>

                {/* Body - Compact List */}
                <div style={{
                    padding: '0',
                    overflowY: 'auto',
                    backgroundColor: '#ffffff',
                    flex: 1
                }}>
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        {results.map((result, idx) => (
                            <div key={idx} style={{
                                display: 'flex',
                                alignItems: 'flex-start',
                                padding: '12px 24px',
                                borderBottom: '1px solid #f0f0f0',
                                backgroundColor: result.success ? '#ffffff' : '#fffcfc'
                            }}>
                                {result.success ? (
                                    <i className="fas fa-check-circle" style={{ color: '#198754', fontSize: '16px', marginTop: '3px', marginRight: '12px' }}></i>
                                ) : (
                                    <i className="fas fa-times-circle" style={{ color: '#dc3545', fontSize: '16px', marginTop: '3px', marginRight: '12px' }}></i>
                                )}
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '2px' }}>
                                        {result?.fileName && <span style={{ fontWeight: '500', color: '#333', fontSize: '14px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                            {result.fileName}
                                        </span>}
                                        <span style={{
                                            fontSize: '12px',
                                            fontWeight: '500',
                                            color: result.success ? '#198754' : '#dc3545',
                                            marginLeft: result?.fileName ? '12px' : 0,
                                            whiteSpace: 'nowrap'
                                        }}>
                                            {result?.messageTitle ?? result?.message}
                                        </span>
                                    </div>
                                    {!result.success && result.message && (
                                        <div style={{
                                            color: '#666',
                                            fontSize: '12px',
                                            fontFamily: 'monospace',
                                            wordBreak: 'break-all',
                                            marginTop: '4px',
                                            lineHeight: '1.4'
                                        }}>
                                            {result.message}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    padding: '12px 24px',
                    backgroundColor: '#fafafa',
                    borderTop: '1px solid #eaeaea',
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}>
                    <button
                        onClick={() => setShowPopup(false)}
                        style={{
                            backgroundColor: '#ffffff',
                            color: '#333',
                            border: '1px solid #ccc',
                            padding: '6px 16px',
                            borderRadius: '4px',
                            fontSize: '13px',
                            fontWeight: '500',
                            cursor: 'pointer'
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ResponsePopup;